// Returns 'do' for ordinals (1st, 2nd...) or 'd' for plain day.
// In France the ordinal is not used to indicate the day of the month.
//
// Locale can be from different sources, e.g. routing locale or i18n.language.
export const getDayOrdinal = (locale: string) =>
  ['fr-fr', 'fr'].includes(locale?.toLowerCase()) ? 'd' : 'do';
